export default __webpack_public_path__ + "static/media/at_logo.3a704f96.png";